/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Appointment/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Action from './Action/index'
import Color from './Color/index'
import Confirmed from './Confirmed/index'
import Name from './Name/index'
import Profile from './Profile/index'
import React from 'react'
import State from './State/index'
import Time from './Time/index'
import Type from './Type/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Appointment({
  children,
  viewPath = "/App/Account/WaitingRoom/Content/Content/Agenda/Appointments/Content/Appointment",
  onMouseEnter,
  onMouseLeave,
  isHoveredManual,
  onMouseEnterName,
  onMouseLeaveName,
  hoveredName
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({onMouseEnter,onMouseLeave})
let appointmentBookingItemIsFirstValueData = fromData.useDataValue({ viewPath,
context: 'appointment_booking_item',
path: 'isFirst',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsGreen100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.100'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  onMouseEnter,
  onMouseLeave,
  isHoveredManual,
  onMouseEnterName,
  onMouseLeaveName,
  hoveredName
  
})
  return (<React.Fragment
>
<div
  data-testid="Appointment.Horizontal"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 onMouseOver={onMouseEnter}
 onMouseLeave={onMouseLeave}
 style={{'--pt-2-dUIJ5': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pb-3-dUIJ5': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pr-4-dUIJ5': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pl-5-dUIJ5': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bc-6-dUIJ5': isHoveredManual ? dtColorsGreen100 : dtColorsWhite,'--mt-1-dUIJ5': appointmentBookingItemIsFirstValueData ? "0px" : "4px"}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Appointment.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<Action
  viewPath={`${viewPath}/Action`}
 is_hovered={isHoveredManual}
/>
</div>
<Color
  viewPath={`${viewPath}/Color`}
/>
<div
  data-testid="Appointment.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<Profile
  viewPath={`${viewPath}/Profile`}
/>
<div
  data-testid="Appointment.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Appointment.Horizontal:3"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal3}`}
>
<div
  data-testid="Appointment.Horizontal:4"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal4}`}
>
<State
  viewPath={`${viewPath}/State`}
/>
<Confirmed
  viewPath={`${viewPath}/Confirmed`}
/>
</div>
<div
  data-testid="Appointment.Horizontal:5"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal5}`}
>
<Time
  viewPath={`${viewPath}/Time`}
/>
</div>
</div>
<div
  data-testid="Appointment.Horizontal:6"
  data-view-path={viewPath}
 onMouseEnter={onMouseEnterName}
 onMouseLeave={onMouseLeaveName}
 className={`views-block ${styles.Horizontal6}`}
>
<Name
  viewPath={`${viewPath}/Name`}
 hovered={hoveredName}
/>
</div>
<Type
  viewPath={`${viewPath}/Type`}
/>
</div>
</div>
</div>
{children}
</React.Fragment>)
}